import { Injectable } from '@angular/core';
import { AppHttpClient } from './app-http-client.service';
import { Observable, map } from 'rxjs';
import { LocalStorageService } from './local-storage.service';
import { FeeSummary, FeeSummaryModel } from '../models/fee.model';

@Injectable({
  providedIn: 'root',
})
export class PaymentService {
  constructor(public http: AppHttpClient, private ls: LocalStorageService) {}

  getFeeSummary(appId: string, feeSummaryId: string): Observable<FeeSummary> {
    return this.http
      .get('fee-summary?appId=' + appId + '&feeSummaryId=' + feeSummaryId)
      .pipe(
        map((res: any) => {
          return new FeeSummary(res.feeSummary as FeeSummaryModel);
        })
      );
  }

  getFeeSummaryBytoken(token:string){
    return this.http
      .get('fee-summary/token/' + token)
      .pipe(
        map((res: any) => {
          return new FeeSummary(res.feeSummary as FeeSummaryModel);
        })
      );
  }

  saveFeeSummary(feeSummary: FeeSummary) {
    return this.http
      .post('fee-summary', feeSummary)
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }
  /*
  feeSummary(params: any) {
    return this.http
      .get(
        'fee-summary?appId=' +
          params['appId'] +
          '&feeSummaryId=' +
          params['feeSummaryId']
      )
      .pipe(
        map((res) => {
          return res;
        })
      );
  }
*/
  preparePayment(url: string, payload: any) {
    return this.http.post(url, payload).pipe(
      map((res) => {
        return res;
      })
    );
  }

  // ==========================================
  // Standalone Payment Methods (New API)
  // ==========================================

  /**
   * Creates a new standalone payment (not linked to an application).
   * Calls POST /api/payment/create
   */
  createStandalonePayment(description: string, amount: number): Observable<any> {
    const payload = {
      description: description,
      amount: amount
    };
    return this.http.post('payment/create', payload).pipe(
      map((res: any) => res)
    );
  }

  /**
   * Prepares a standalone payment for Tyler redirect.
   * Calls POST /api/payment/prepare
   * Line items are built by backend from FeeSummary.
   */
  prepareStandalonePayment(feeSummaryId: string, appId: string): Observable<any> {
    const url = `payment/prepare?feeSummaryId=${feeSummaryId}&appId=${appId}`;
    return this.http.post(url, {}).pipe(
      map((res: any) => res)
    );
  }

  /**
   * Verifies a standalone payment after Tyler callback.
   * Calls GET /api/payment/verify
   */
  verifyStandalonePayment(token: string, feeSummaryId: string, appId: string): Observable<any> {
    const url = `payment/verify?token=${token}&feeSummaryId=${feeSummaryId}&appId=${appId}`;
    return this.http.get(url).pipe(
      map((res: any) => res)
    );
  }

  /**
   * Gets a standalone payment by feeSummaryId for confirmation page.
   * Calls GET /api/payment/{feeSummaryId}
   */
  getStandalonePayment(feeSummaryId: string, appId: string): Observable<any> {
    return this.http.get(`payment/${feeSummaryId}?appId=${appId}`).pipe(
      map((res: any) => res)
    );
  }

  // ==========================================
  // App-Linked Payment Methods (New API)
  // ==========================================

  /**
   * Prepares an app-linked payment for Tyler redirect.
   * Calls POST /api/payment/prepare
   * Line items are built by backend from FeeSummary.
   */
  prepareAppLinkedPayment(feeSummaryId: string, appId: string): Observable<any> {
    const url = `payment/prepare?feeSummaryId=${feeSummaryId}&appId=${appId}`;
    return this.http.post(url, {}).pipe(
      map((res: any) => res)
    );
  }

  /**
   * Verifies an app-linked payment after Tyler callback.
   * Calls GET /api/payment/verify
   */
  verifyAppLinkedPayment(token: string, feeSummaryId: string, appId: string): Observable<any> {
    const url = `payment/verify?token=${token}&feeSummaryId=${feeSummaryId}&appId=${appId}`;
    return this.http.get(url).pipe(
      map((res: any) => res)
    );
  }

  /**
   * Gets payment details by feeSummaryId and appId.
   * Calls GET /api/payment/{feeSummaryId}?appId={appId}
   */
  getPayment(feeSummaryId: string, appId: string): Observable<any> {
    return this.http.get(`payment/${feeSummaryId}?appId=${appId}`).pipe(
      map((res: any) => res)
    );
  }
}
